<template>
  <div id="workOrderInfo">
    <el-row class="clearfix" style="margin-bottom: 15px;">
      <el-col class="fl" :span="2">
        <el-button size="small"  type="warning" @click="backGo()">返回</el-button>
      </el-col>
      <el-col class="fr" :span="1">
        <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;" @click="refresh()"></i>
      </el-col>
    </el-row>
    <el-col class="fl searthPart" style="width: 35%;">
      <p class="headerT fl" style="width: 120px;">工单信息</p>
      <el-button class="fl" size="small"  type="success" style="margin: -5px 0 0 0px;">已完成</el-button>
      <!-- <el-button class="fl" size="small"  type="success" style="margin: -5px 0 0 0px;">已确认</el-button> -->
      <el-button class="fl" size="small"  type="danger" style="margin: -5px 0 0 20px;">工程师：李某某</el-button>
      <i class="el-icon-star-off fl" style="font-size:20px;margin-left: 20px;"></i>
      <div class="clearfix"></div>
      <el-form ref="orderInfoForm" :model="orderInfoForm" label-width="120px" :label-position="labelPosition">
        <el-form-item label="工单编号"  prop="orderNumber">
          <el-input disabled v-model="orderInfoForm.orderNumber">
          </el-input>
          <i class="iconfont hohofast-copy copyBtn" @click="handleCopy(orderInfoForm.orderNumber,$event)"></i>

        </el-form-item>
        <!-- <el-form-item label="售后订单"  prop="orderType">
          <el-input disabled v-model="orderInfoForm.orderNumber">
          </el-input>
          <i class="iconfont hohofast-copy copyBtn" @click="handleCopy(orderInfoForm.orderNumber,$event)"></i>

        </el-form-item> -->
        <el-form-item label="工单类型"  prop="orderType">
          <el-input disabled v-model="orderInfoForm.orderType">
          </el-input>
        </el-form-item>
        <el-form-item label="渠道来源"  prop="orderSource">
          <el-input disabled v-model="orderInfoForm.orderSource">
          </el-input>
        </el-form-item>
        <el-form-item label="客户姓名">
          <el-input disabled v-model="orderInfoForm.clientName" ></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input disabled v-model="orderInfoForm.clientPhone" ></el-input>
          <i class="iconfont hohofast-copy copyBtn" @click="handleCopy(orderInfoForm.clientPhone,$event)"></i>

        </el-form-item>
        <el-form-item label="省市区">
          <el-input style="width: 28%;" disabled v-model="orderInfoForm.sheng" ></el-input>
          <el-input style="width: 28%;" disabled v-model="orderInfoForm.shi" ></el-input>
          <el-input style="width: 28%;" disabled v-model="orderInfoForm.qu" ></el-input>
        </el-form-item>
        <el-form-item label="详细地址">
          <el-input disabled v-model="orderInfoForm.clientAddress" ></el-input>
          <i class="iconfont hohofast-copy copyBtn" @click="handleCopy(orderInfoForm.sheng+orderInfoForm.shi+orderInfoForm.qu+orderInfoForm.clientAddress,$event)"></i>
         </el-form-item>
        <el-form-item label="预约时间">
          <el-input disabled v-model="orderInfoForm.appoTime" ></el-input>
        </el-form-item>
      </el-form>
      <p class="headerT">维修信息</p>
      <el-form ref="orderInfoForm" :model="orderInfoForm" label-width="120px" :label-position="labelPosition">
        <el-form-item label="IMEI" prop="IMEI">
          <el-input disabled v-model="orderInfoForm.IMEI" ></el-input>
        </el-form-item>
        <el-form-item label="品牌" prop="brand">
          <el-input disabled v-model="orderInfoForm.brand" ></el-input>
        </el-form-item>
        <el-form-item label="品类" prop="category">
          <el-input disabled v-model="orderInfoForm.category" ></el-input>
        </el-form-item>
        <el-form-item label="型号" prop="model">
          <el-input disabled v-model="orderInfoForm.model" ></el-input>
        </el-form-item>
        <el-form-item label="颜色" prop="color">
          <el-input disabled v-model="orderInfoForm.color" ></el-input>
        </el-form-item>
        <el-form-item label="故障" prop="fault">
          <el-input disabled v-model="orderInfoForm.fault" ></el-input>
        </el-form-item>
      </el-form>
      <p class="headerT">支付信息</p>
      <el-form ref="orderInfoForm" :model="orderInfoForm" label-width="120px" :label-position="labelPosition">
        <el-form-item label="故障金额" prop="faultPrice">
          <el-input disabled v-model="orderInfoForm.faultPrice" ></el-input>
        </el-form-item>
        <el-form-item label="折扣" prop="discount">
          <el-input disabled v-model="orderInfoForm.discount" ></el-input>
        </el-form-item>
        <el-form-item label="应付金额" prop="payAmount">
          <el-input disabled v-model="orderInfoForm.payAmount"></el-input>
        </el-form-item>
        <el-form-item label="实付金额" prop="realAmount">
          <el-input disabled v-model="orderInfoForm.realAmount"></el-input>
        </el-form-item>
        <el-form-item label="收钱吧流水号" prop="moneyNumber">
          <el-input disabled v-model="orderInfoForm.payAmount"></el-input>
        </el-form-item>
        <el-form-item label="到账情况" prop="moneyStutas">
          <el-input disabled v-model="orderInfoForm.moneyStutas"></el-input>
        </el-form-item>
      </el-form>
    </el-col>
    <el-col class="fr" style="width: 62%;">
      <el-button-group style="margin-bottom: 20px;">
        <el-button :class="{activeBtn:activeBtnIndex === index}" v-for="(item,index) in orderStates" @click="changeState(item,index)" :key="index">{{item.name}}</el-button>
      </el-button-group>
      <!-- <p class="headerT">供应商信息详情</p> -->
      <el-card class="box-card fr" style="width: 100%;" v-if="activeBtnIndex ==0">
        <quill-editor ref="myTextEditor" v-model="content" :options="editorOption"></quill-editor>
        
        <el-dropdown split-button type="primary" trigger="click" class="fr" style="margin: 50px 0;">
        提交为
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="DetermineSave()">已确认</el-dropdown-item>
          <el-dropdown-item @click.native="temporarySave()">暂存</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown split-button type="primary" trigger="click" class="fr" style="margin: 50px 20px 50px 0;">
        {{pageStatus}}
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="goOnSave()">留在当前页面</el-dropdown-item>
          <el-dropdown-item @click.native="closeSave()">离开当前页面</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
        <el-button type="primary" class="fr" style="margin: 50px 20px 50px 0;" @click="submitEditor()">提交</el-button>
      </el-card>
      <el-row  v-if="activeBtnIndex ==1">
        <ul>
          <li v-for="(item,index) in procurementEvents" :key="index" class="eventLi">
            <span class="createTime childSpan clearfix" v-if="item.createTime">
              <i class="fl"></i>
              <span class="fl">{{formatTime(item.createTime)}}</span><br>
            </span>
            <span class="details childSpan" v-if="item.details">{{item.details}}<br></span>
            <span class="attribute1 childSpan" v-if="item.attribute1">
              {{item.attribute1.substring(0,item.attribute1.lastIndexOf('：')+1)}}
              <span class="orderId">
              {{item.attribute1.substring(item.attribute1.lastIndexOf('：')+1,)}}
              </span><br>
            </span>
            <span class="attribute2 childSpan" v-if="item.attribute2">
              <!-- {{item.attribute2}}<br> -->
              {{item.attribute2.substring(0,item.attribute2.lastIndexOf('：')+1)}}
              <span class="orderId">
              {{item.attribute2.substring(item.attribute2.lastIndexOf('：')+1,)}}
              </span><br>
            </span>
            <span class="attribute3 childSpan" v-if="item.attribute3">
              <!-- {{item.attribute3}}<br> -->
              {{item.attribute3.substring(0,item.attribute3.lastIndexOf('：')+1)}}
              <span class="orderId">
              {{item.attribute3.substring(item.attribute3.lastIndexOf('：')+1,)}}
              </span><br>
            </span>
          </li>
        </ul>
        <!-- <h2>{{valueTime}}</h2> -->
      </el-row>
    </el-col>
  </div>
</template>

<script>
  let moment = require("moment");
  import Vue from 'vue'
  import axios from 'axios'
  import clip from '@/util/clipboard'
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import { quillEditor } from 'vue-quill-editor'
  import {
      
    } from "../../api/api";
  export default {
    name: 'workOrderInfo',
    components: {
      quillEditor
    },
    data () {
      return {
        pageStatus:'留在当前页面',
        content:'',
        editorOption: {
          placeholder: 'Hello World'
        },
        faultClassCheckList:[],
        faultCheckList:[],
        orderInfoForm:{
          orderNumber:'JHH201808140002',
          orderType:'上门维修',
          olderOrderCode:'',
          orderSource:'微信',
          clientName:'王先生',
          clientPhone:'18566994523',
          orderInfoTime:'',
          sheng:'上海市',
          shi:'上海市',
          qu:'长宁区',
          clientAddress:'定西路788号 5楼 5G',
          appoTime:'2019-1-30 12：00-14：00',
          IMEI:'1234567890',
          brand:'苹果 APPLE',
          category:'iPhone',
          model:'iPhone X',
          color:'银色',
          faultClass:'',
          fault:'外屏碎  299元',
          faultPrice:'599',
          discount:'0.95',
          payAmount:'569',
          realAmount:'569',
          moneyNumber:'56568923659564656565256', 
          moneyStutas:'已到账'
        },
        mapJson:'../static/json/map.json',
        province:'',
        sheng: '',
        shi: '',
        shi1: [],
        qu: '',
        qu1: [],
        city:'',
        block:'',
        valueTime:'',
        orderId:'',
        activeBtnIndex:0,
        orderStates:[{name:'工单回复'},{name:'工单事件'},],
        labelPosition:'left',
        returnData: [
          { 
            materialCoding:'',
            materialName:'', 
            number:'', 
            price:'', 
            amout:'', 
            aogSum:'', 
            aogPercentage:'', 
            salesReturnSum:'', 
            salesReturnPercentage:'',
          },
        ],
        //分页变量
        pages:{
          total: 0,
          page: 1,
          pageSize: 10,
        },
      }
    },
    mounted () {
      // if (!this.$route.query.orderId) {
      //   var userOrderId = sessionStorage.getItem('saveOrderId');
      //   this.orderId = JSON.parse(userOrderId);
      // }else{
      //   let orderId = this.$route.query.orderId
      //   this.orderId = orderId
      // }
      // this.getPurchaseOrdersInfo()
      // if (this.returnData.amout > 0) {
      //   this.returnData.amout = this.toThousands2(this.returnData.amout)
      // }
      
    },
    methods: {
      
      //时间转化函数
      formatTime (ndate) {
        if (!ndate) {
          return '-'
        }
        const date = new Date(ndate)
        var year = date.getFullYear()
        var month = date.getMonth() + 1
        var day = date.getDate()
        var hour = date.getHours()
        var minute = date.getMinutes()
        var second = date.getSeconds()
        if (month >= 1 && month <= 9) {
          month = '0' + month
        }
        if (day >= 0 && day <= 9) {
          day = '0' + day
        }
        if (hour >= 0 && hour <= 9) {
          hour = '0' + hour
        }
        if (minute >= 0 && minute <= 9) {
          minute = '0' + minute
        }
        if (second >= 0 && second <= 9) {
          second = '0' + second
        }
        var result = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
        return result
      },
      //金额转化函数
      addCommas:function(row,column){
        var num = row[column.property];
        var b= num.toString().replace(/\$|\,/g,'');
        if(isNaN(num))
            num = "0";
        var sign = (num == (num = Math.abs(num)));
        num = Math.floor(num*100+0.50000000001);
        var cents = num%100;
        num = Math.floor(num/100).toString();
        if(cents<10)
        cents = "0" + cents;
        for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
        num = num.substring(0,num.length-(4*i+3))+','+
        num.substring(num.length-(4*i+3));
        return (((sign)?'':'-') + num + '.' + cents);
      },
      toThousands2(num) {
        // this.materForm.backUpPrice = num
        // var num = row[column.property];
        num = num.toString().replace(/\$|\,/g,'');
        if(isNaN(num))
            num = "0";
        var sign = (num == (num = Math.abs(num)));
        num = Math.floor(num*100+0.50000000001);
        var cents = num%100;
        num = Math.floor(num/100).toString();
        if(cents<10)
        cents = "0" + cents;
        for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
        num = num.substring(0,num.length-(4*i+3))+','+
        num.substring(num.length-(4*i+3));
        return (((sign)?'':'-') + num + '.' + cents);
      },
      //获取订单详情
      getPurchaseOrdersInfo() {
        let para={
          id: this.orderId,
        }
        getPurchaseOrdersInfo(para).then(res => {          
          if (res.data.status==100) {            
            // console.log(res.data.results)  
            this.returnData = res.data.results.purchaseDetails.list
            this.returnData.forEach((item) =>{
              return item.amout = item.price*item.number
            })
            // this.returnData.amout = this.returnData.number * this.returnData.price 
            this.purchaseForm = res.data.results.purchaseOrdersInfo
            this.purchaseForm.purchaseTime = moment(res.data.results.purchaseOrdersInfo.purchaseTime).format("YYYY-MM-DD");
            this.purchaseForm.aogTime = moment(res.data.results.purchaseOrdersInfo.aogTime).format("YYYY-MM-DD");
            sessionStorage.setItem('saveOrderId', JSON.stringify(res.data.results.purchaseOrdersInfo.id));
            this.procurementEvents = res.data.results.procurementEvents
            
          }else{
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) =>{
          this.$Message.error(error.message);
        })
      },
      tabRemove (targetName) {
          // 首页不可删除
          if(targetName == '/') {
            return;
          }
          //将该tab从options里移除
          this.$store.commit('delete_tabs', targetName);
          ////还同时需要处理一种情况当需要移除的页面为当前激活的页面时，将上一个tab页作为激活tab
          if (this.activeIndex === targetName) {
            // 设置当前激活的路由
            if (this.options && this.options.length >= 1) {
              this.$store.commit('set_active_index', this.options[this.options.length-1].route);
              this.$router.push({path: this.activeIndex});
            } else {
              this.$router.push({path: '/welcome'});
            }
          }
        },
      //复制内容
      handleCopy(text, event) {
         clip(text, event)
         console.log(text)
      },
      //返回上一页
      backGo() {
        this.$router.push({
          path:'/workOrderManage'
        })
      },
      refresh() {
        this.getPurchaseOrdersInfo()
      },
     //切换订单详情与订单事件
      changeState(item,index) {
        this.activeBtnIndex = index
       },
      onEditorChange({ editor, html, text }) {
        this.content = html
      },
      submitEditor() {
        console.log(this.content)
        this.$message.success('提交成功！')
      },
      //已提交
      DetermineSave(){
        this.saveStatus = 'YQR';
        if (this.purchaseOrderForm.supplier==""||this.purchaseOrderForm.supplierName==""||this.purchaseOrderForm.paymentTime==""||this.purchaseOrderForm.purchaseTime==""||this.purchaseOrderForm.aogTime==""||this.returnData=="") {
          this.$message({
            message: '请补全产品信息，再提交！',
            type: 'warning'
          });
          
        }else{
          let para={
          supplier: this.purchaseOrderForm.supplier,
          supplierName: this.purchaseOrderForm.supplierName,
          paymentTime: this.purchaseOrderForm.paymentTime,
          purchaseTime: this.purchaseOrderForm.purchaseTime,
          aogTime: this.purchaseOrderForm.aogTime,
          status: this.saveStatus,
          amout: this.backupAmout,
          sum: this.sum,
          purchaseDetails: this.returnData,
        }
        // console.log(para)
        purchaseOrdersAdd(para).then(res => {
          if (res.data.status==100) {
            // this.$message({
            //   message: res.data.message,
            //   type: "success"
            // });
            if (this.pageStatus == '留在当前页面') {
              this.dialogVisible = false
              this.purchaseOrderForm = {}
              this.returnData = []
            }else{
              // parent.location.reload();
              this.tabRemove(this.$route.path)
              this.$router.replace({
                path:'/purchaseOrderManage'
              })
            }
           
          }else{
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) =>{
          this.$Message.error(error.message);
        })
        }
      },
      closeSave(){
        // alert('1111')
        this.pageStatus = "离开当前页面"
        
      },
      goOnSave(){
        this.pageStatus = "留在当前页面"
        
      },
      //暂存
      temporarySave(){
        this.saveStatus = 'CG';
        if (this.purchaseOrderForm.supplier==""||this.purchaseOrderForm.supplierName==""||this.purchaseOrderForm.paymentTime==""||this.purchaseOrderForm.purchaseTime==""||this.purchaseOrderForm.aogTime==""||this.returnData=="") {
          this.$message({
            message: '请补全产品信息，再提交！',
            type: 'warning'
          });
          
        }else{
          let para={
          supplier: this.purchaseOrderForm.supplier,
          supplierName: this.purchaseOrderForm.supplierName,
          paymentTime: this.purchaseOrderForm.paymentTime,
          purchaseTime: this.purchaseOrderForm.purchaseTime,
          aogTime: this.purchaseOrderForm.aogTime,
          status: this.saveStatus,
          amout: this.backupAmout,
          sum: this.sum,
          purchaseDetails: this.returnData,
        }
        // console.log(para)
        purchaseOrdersAdd(para).then(res => {
          if (res.data.status==100) {
            if (this.pageStatus == '留在当前页面') {
              this.dialogVisible = false
              this.purchaseOrderForm = {}
              this.returnData = []
            }else{
              // parent.location.reload();
              this.tabRemove(this.$route.path)
              this.$router.replace({
                path:'/purchaseOrderManage'
              })
            }
          }else{
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) =>{
          this.$Message.error(error.message);
        })
        }
      },
    },
    watch: {
      
    },
    
  }
</script>

<style type="text/css" lang="scss" scoped>
  #workOrderInfo{
    font-size: 14px;
    .copyBtn{font-size: 24px;cursor: pointer;display:block;float: right;}
    .el-input{width: 85%;}
    .headerT{font-size: 16px;margin:0 0 15px 0;}
    .activeBtn{background-color: #1abc9c;color:#fff;}
    .eventLi{border-left:1px solid #1abc9c;padding-bottom: 20px;
      .childSpan{padding-left: 20px;margin-bottom: 5px;}
      .childSpan:first-child{padding-left: 0px;margin:-5px 0 0 -5px;}
      .childSpan span.orderId{color: #3399FF;}
      .createTime i{display: block;width: 10px;height: 10px;border-radius: 20px;
        background-color: #1abc9c;margin: 0px 15px 0px -5px;}
    }
    .toolbar{float: none;}
    .el-step__line{background-color: #1abc9c;}
    .el-step__icon-inner{color:#1abc9c;}
    /*.el-step__icon{width: 10px;height: 10px;}*/
    .el-step__icon.is-text{border-color: #1abc9c;}
  }
  
</style>



// WEBPACK FOOTER //
// workOrderInfo.vue?1c934395